import { render, staticRenderFns } from "./RobotStatistics.vue?vue&type=template&id=416661b2&scoped=true&"
import script from "./RobotStatistics.vue?vue&type=script&lang=js&"
export * from "./RobotStatistics.vue?vue&type=script&lang=js&"
import style0 from "./RobotStatistics.vue?vue&type=style&index=0&id=416661b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416661b2",
  null
  
)

export default component.exports